import EllipsesMenu from "./EllipsesMenu";
export type OptionsMenuProps = {
  name: string;
  functionMenu: any;
};
export type ColumnActionsDropdownProps = {
  name: string;
  options: OptionsMenuProps[];
  toggleOpen: () => void;
  onClick?: () => void;
  moreButton?: boolean;
  isLast?: boolean;
};

const ColumnActionsDropdown: React.FC<ColumnActionsDropdownProps> = ({
  name,
  options,
  toggleOpen,
  onClick,
  moreButton = true,
  isLast = false,
}) => {
  return (
    <td className="relative whitespace-nowrap py-5 pl-3 pr-4 text-right text-sm font-medium sm:pr-0 flex">
      {onClick && (
        <a
          onClick={() => onClick?.()}
          className="text-primary-600 hover:text-primary-900 mr-4 cursor-pointer"
        >
          Editar<span className="sr-only">, {name}</span>
        </a>
      )}
      {moreButton && (
        <EllipsesMenu
          name="options"
          options={options}
          onclick={toggleOpen}
          isLast={isLast}
        />
      )}
    </td>
  );
};

export default ColumnActionsDropdown;
